export const APP_MANAGED_ROUTES = {
  LANDING_PAGE: '/',
  HOME: '/home',
  CAREGIVER_HOME: '/caregiver-home',
  SIGN_IN: '/sign-in',
  SIGN_OUT: '/sign-out',
  SUPPORT: '/support',
};
